import { BannerProps } from './models/BannerProps';
import { GlobalBanner } from './styles/styles';

export const GlobalBannerMessage = ({ message }: BannerProps) => (
  <GlobalBanner style={{ display: 'flex', alignItems: 'center' }}>{message.text}</GlobalBanner>
);
